/* eslint-disable @typescript-eslint/no-explicit-any */
import { RoutesType } from '../config';
import { useRouting } from './routing.hook';

import { AnyFunction } from 'types';

// We do it like this to be easier to define the type without tapping in
// the complex RoutesType type
type RouteParams<Route extends { getPath?: (params: any) => void; path: string }> =
  Route['getPath'] extends AnyFunction ? Parameters<Route['getPath']> : [];

/**
 *
 * @param targetRoute the route you want to navigate to
 * @param params the parameters that construct the route you want to; Can be required or not
 * @returns A function that executes the navigation, no parameters needed
 */
export function useDirectNavigation<Target extends keyof RoutesType>(
  targetRoute: Target,
  ...params: RouteParams<RoutesType[Target]>
): () => void {
  const routing = useRouting();

  return () => routing[targetRoute](...(params as any));
}
